<template>
    <div class="flex justify-between">
        <h2 class="font-bold text-4xl dark:text-gray-200">
            Welcome back, {{ name }}!
        </h2>
    </div>
</template>

<script>
export default {
    name: "DashboardHeadTitleSlot",
    props: {
        name: {
            type: String,
            required: true,
        }
    },
}
</script>

<style scoped>

</style>
